module.exports = __webpack_public_path__ + "img/phone_primary.5c509d9e.svg";